import { Component } from "@angular/core";
import { EdpToastType } from "../edp-toast-type";
import { EdpToastContainerComponent as ToastContainerComponent } from "../edp-toast-container/edp-toast-container.component";
import { Router } from "@angular/router";
import { RegionActionsService } from "@edp-services/region-actions.service";

@Component({
    selector: "edp-toast-item",
    templateUrl: "./edp-toast-item.component.html",
    styleUrls: ["./edp-toast-item.component.scss"],
})
export class EdpToastItemComponent {
    private parentComponent: ToastContainerComponent;
    public message = "&nbsp;";
    public type: EdpToastType = EdpToastType.info;
    public isDirect = false;
    public showIcon = true;
    public showCloseButton = true;
    public classList: string[];
    public closeCallback: any;
    public isClosing = false;
    public showCloseModalButton = false;
    public textCloseModalButton: string;
    public textButton = "OK";
    public route: string;

    public iconClassList = {
        info: "icon-edponline-Bop-025",
        success: "icon-edponline-Bop-072",
        warning: "icon-edponline-Bop-070",
        error: "icon-edponline-Bop-071",
        danger: "icon-edponline-Bop-071",
    };
    // tslint:disable-next-line: ban-types
    public functionOnClickClose: Function = () => {};
    public functionCloseButton: Function = () => {};

    constructor(private router: Router, private regionActionsService: RegionActionsService) {}

    public setParentComponent(parent: ToastContainerComponent) {
        this.parentComponent = parent;
    }

    public onClose(evt?: Event) {
        if (evt && evt.type === "click" && this.functionOnClickClose) {
            this.functionOnClickClose();
        }

        if (evt) {
            evt.stopPropagation();
        }

        this.isClosing = true;
        if (this.closeCallback) {
            // waithing for the out animation to end (refer to
            // the scss file to see the animation lenght)
            setTimeout(this.closeCallback.bind(this, evt), 500);
        }
    }

    public onclick(evt: Event) {
        if (!this.isDirect && this.parentComponent && this.parentComponent.isOpen()) {
            evt.stopPropagation();
        }
    }

    public closeModal(event: Event) {
        this.onClose(event);
        if (!!this.route) {
            this.router.navigate([this.route]);
            return;
        }

        if (event && event.type === "click" && this.functionCloseButton) {
            this.functionCloseButton();
            return;
        }

        this.regionActionsService.goToStartPage();
    }
}
